
export default {
  name: "ContadoresStatus",
  props: {
    total: Number,
    aguardando: Number,
    emAnalise: Number,
    rejeitadas: Number,
    aprovadas: Number,
    canceladas: Number,
    aguardandoCancelamento: Number,
  },
};
